// Shared helpers + StatusPill used across the GymSales admin sub-components.
import React from 'react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmtRel = (iso) => {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return `${Math.floor(ms / 1000)}s ago`;
  if (ms < 3600_000) return `${Math.floor(ms / 60_000)}m ago`;
  if (ms < 86_400_000) return `${Math.floor(ms / 3_600_000)}h ago`;
  return `${Math.floor(ms / 86_400_000)}d ago`;
};

// HTTP status pill with colour-coded semantics. `ok` is passed separately
// because 2xx codes count as success regardless of the numeric range and
// we sometimes want to force-colour a non-2xx as green (e.g. 302 on
// sandbox appointments is expected).
export const StatusPill = ({ code, ok }) => {
  let cls = 'bg-slate-500/20 text-slate-300 border-slate-500/40';
  if (ok) cls = 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40';
  else if (code === 429) cls = 'bg-amber-500/20 text-amber-300 border-amber-500/40';
  else if (code === 401 || code === 403) cls = 'bg-rose-500/20 text-rose-300 border-rose-500/40';
  else if (code === 404) cls = 'bg-slate-500/20 text-slate-300 border-slate-500/40';
  else if (code === 302 || code === 301) cls = 'bg-indigo-500/20 text-indigo-300 border-indigo-500/40';
  else if (code >= 400) cls = 'bg-rose-500/20 text-rose-300 border-rose-500/40';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded border text-[11px] font-mono font-bold ${cls}`}>
      {code == null ? 'ERR' : code}
    </span>
  );
};
